const INFO = {
	main: {
		title: "Stephen Gray - Portfolio",
		name: "Stephen Gray",
		email: "stephengray7505@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		github: "https://github.com/cassinihx",
		linkedin: "https://linkedin.com/in/stephengray7505",
		instagram: "https://instagram.com/freethecloudy",
		CV: "/Stephen-Gray-CV.pdf"
	},

	homepage: {
		title: "DevOps-focused Engineer, Former SysAdmin.",
		description:
			"With a background in systems administration, I’m transitioning into DevOps and building hands-on projects across infrastructure, automation, and cloud platforms including Azure and Cloudflare. I enjoy solving complex operational problems with a strong focus on scalability, security awareness, and usability. Welcome to my React.JS portfolio site.",
		},

	about: {
		title: "I'm Stephen, a Bristol based technology enthusiast.",
		description:
			`I've worked on a range of projects over the years. From migrations from G Apps (Now Google Workspace) to Office 365, Information Security management, ISO27001 implementation, Database migration / Data conversion, CDN administration (RHEL7, Cloudflare, AWS, IBM DB2), maintenance and troubleshooting. I have a broad professional skillset.
			\n
			In my spare time I can be found working with Emmaus, an NGO seeking to end homelessness, persuing my own coding projects, working on my car or enjoying some off-time with a good film.`,
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
						{
			title: "Terraform Project",
			description:
				"A 'Hello-World' style Terraform project, a first soirée into IaC. Terraform > AWS Networking > Container Platform > Load Balancer > Live Web Service",
			logos: ["https://logo.svgcdn.com/devicon/terraform-original.png",
				"https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Amazon_Web_Services_Logo.svg/960px-Amazon_Web_Services_Logo.svg.png?20170912170050"
			],
			openInPopup: true,
			linkText: "View Github",
			link: "https://github.com/cassinihx/Terraform-Portfolio-Project/",
			secondLinkText: "View Deployment",
			secondLink: "http://35.178.239.187/",
		},
						{
			title: "LIVE UniFi Home-Lab Grafana",
			description:
				"Docker > Unifi Poller > Prometheus > Grafana > Cloudflared",
			logos: ["https://raw.githubusercontent.com/grafana/grafana/main/public/img/grafana_icon.svg",
				"https://unpoller.com/img/logo.png",
				"https://prometheus.io/_next/static/media/prometheus-logo.7aa022e5.svg",
				"https://www.gravatar.com/avatar/c2d72241e196b5c37c53acabbabb6a74?s=120&r=g&d=404"
			],
			openInPopup: true, 
			linkText: "Open Grafana",
			link: "https://graf.stephen-gray.co.uk/public-dashboards/86ada38b63b343da9f32f5ed24af5e5b",		

		},
				{
			title: "Website and Brand Design - HTML, CSS, JS, Adobe CC",
			description:
				"A bespoke brand design and website package for Tracy Blackmore. hosted via Cloudflare",
			logos: ["https://cdn.jsdelivr.net/npm/programming-languages-logos@0.0.3/src/html/html.png",
				"https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/500px-CSS3_logo_and_wordmark.svg.png?20160530175649",
				"https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
				"https://www.gravatar.com/avatar/c2d72241e196b5c37c53acabbabb6a74?s=120&r=g&d=404"
			],
			openInPopup: true, 
			linkText: "Visit the website",
			link: "https://tracyblackmore.co.uk",	
		},
				{
			title: "FACE VALUE - Python + Selenium",
			description:
				"Dissertation - FR Human Search app using Python + Selenium + Supporting research. ",
			logos: ["https://cdn.jsdelivr.net/npm/programming-languages-logos@0.0.3/src/python/python.png",
				"https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Selenium_Logo.png/960px-Selenium_Logo.png?20200511151950"

			],
			linkText: "View Project",
			link: "https://github.com/cassinihx/FACE-VALUE",
		},
						{
			title: "Streetlight - Unity + C#, Python + llama.cpp + Deepseek + OpenStreetMaps API",
			description:
				"Prototype AI Powered Kiosk leveraging Machine Learning to provide access to support services 24/7",
			logos: ["https://cdn.jsdelivr.net/npm/programming-languages-logos@0.0.3/src/python/python.png",
				"https://upload.wikimedia.org/wikipedia/commons/thumb/c/c6/Unity_Hub_Logo.png/640px-Unity_Hub_Logo.png",
				"https://pypi-camo.freetls.fastly.net/c764f7e6f4adf3fbd414c1f6246128b002e2dbc2/68747470733a2f2f7261772e67697468756275736572636f6e74656e742e636f6d2f616265746c656e2f6c6c616d612d6370702d707974686f6e2f6d61696e2f646f63732f69636f6e2e737667",
				"https://cdn.jsdelivr.net/npm/programming-languages-logos/src/csharp/csharp.png",
			],
			linkText: "View Project",
			link: "https://github.com/cassinihx/FACE-VALUE",
		},
		{
			title: "Unity 3D prototype - 'WE ARE ALL HUMAN'",
			description:
				"A prototype museum exhibit built around embodied interactions",
			logos: ["https://cdn.jsdelivr.net/npm/programming-languages-logos/src/csharp/csharp.png",
			"https://upload.wikimedia.org/wikipedia/commons/thumb/c/c6/Unity_Hub_Logo.png/640px-Unity_Hub_Logo.png"],
			openInPopup: true,
			linkText: "Windows build .ZIP Download",
			link: "https://media.stephen-gray.co.uk/Build3.zip",	
			secondLinkText: "WebGL Build",
			secondLink: "https://cassinihx.github.io/UnityInteractiveExhibit/",
		},
		{
			title: "3.js portfolio",
			description:
				"Please take a look at my Three.js portfolio built as a proof of concept for my BSc.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://codesandbox.io/p/devbox/sem1-project-final-q8733m",
		},

		{
			title: "p5.js portfolio",
			description:
				"Early first year p5.js work",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://cassinihx.github.io/p5-Y1-project/projectPrimaryAnimated%20Final/index.html",
		},

		{
			title: "Unity game - C#",
			description:
				"Assets compiled in Adobe Maya and code compiled using C# within the unity engine.",
			logos: ["https://cdn.jsdelivr.net/npm/programming-languages-logos/src/csharp/csharp.png",
				"https://upload.wikimedia.org/wikipedia/commons/thumb/c/c6/Unity_Hub_Logo.png/640px-Unity_Hub_Logo.png"
			],
			openInPopup: true, // Custom key to identify popup behavior
			linkText: "View Project",
			link: "https://cassinihx.github.io/UnityGame/", // Path to Unity game in public folder		
			// secondLinkText: "Github Repo Test",
			// secondLink: "https://github.com/example/repo",
		},

		// {
		// 	title: "Project 3",
		// 	description:
		// 		"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
		// 	logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/html/html.png",
		// 	linkText: "View Project",
		// 	link: "https://github.com",
		// },

		// {
		// 	title: "Project 4",
		// 	description:
		// 		"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
		// 	logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
		// 	linkText: "View Project",
		// 	link: "https://github.com",
		// },

		// {
		// 	title: "Project 5",
		// 	description:
		// 		"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
		// 	logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
		// 	linkText: "View Project",
		// 	link: "https://github.com",
		// },
	],
};

export default INFO;
